import React, { Component } from 'react'
import IntlMessageFormat from 'intl-messageformat'
import shallowEqual from 'fbjs/lib/shallowEqual'

const getKey = (path) => {
  const splitPath = path.split('.')
  return splitPath[splitPath.length - 1]
}

const get = (data, path) => {
  if (typeof path !== 'string') return data

  return path.split('.').reduce(
    (curr, sub) => curr && curr[sub],
    data,
  )
}

const getSubPaths = (locale, paths, root) => {
  const subMessages = get(locale, paths)
  if (!subMessages || typeof subMessages === 'string') {
    return { [getKey(paths)]: paths }
  }

  return Object
    .keys(subMessages)
    .reduce(
      (acc, curr) => ({ ...acc, [curr]: `${root}.${curr}` }),
      {},
    )
}
const formatMessage = (message = '', ...args) => (values) => {
  if (values) {
    try {
      return new IntlMessageFormat(message, ...args).format(values)
    } catch (e) {
      return message
    }
  }
  return message
}

const browserLanguage = window.navigator.language || window.navigator.browserLanguage

const getMessage = (locale, rootPath = '', values) =>  {
  let paths = rootPath
  if (typeof paths === 'string') paths = getSubPaths(locale, paths, rootPath)
  return Object
    .keys(paths)
    .reduce((acc, curr) => {
      const message = get(locale, paths[curr])
      return {
        ...acc,
        [curr]: formatMessage(message, browserLanguage)(values && { ...values, ...values[curr] }) }
    }, {})
}

export default (path) => WrappedComponent => class extends Component {
  static contextTypes = {
    store: () => null, // this is to avoid importing prop-types
  }

  constructor(props, context) {
    super(props, context)
    this.messages = {}
    this.state = {
      injectedProps: {},
    }  
    this.unsubscribe = context.store.subscribe(() => { this.inject() })
  }
  
  
  UNSAFE_componentWillMount() {
    this.inject()
  }

  componentDidUpdate() {
    this.inject()
  }
  componentWillUnmount() {
    this.unsubscribe()
  }
  
  inject = (nextProps) => {
    /* take lang, locale and formats on `store` reducer */
    const { locale } = this.context.store.getState().config
    // in case of locale is not initialized
    if (!locale) return {}

    /* path can be a function, in which case we pass props to it */
    let innerPath = path
    if (typeof path === 'function') innerPath = path(nextProps || this.props)

    /* format messages */
    const messages =  getMessage(locale, innerPath, this.props)

    /* not change messages when the formated messages is identical */
    if (shallowEqual(this.state.injectedProps.messages, messages)) return
    this.setState(state => ({
      ...state,
      injectedProps: { messages },
    }))

    }
    
  render() {
    return (
      <WrappedComponent
        /* this is parent props */
        {...this.props}
        /* this is injected props from hoc */
        {...this.state.injectedProps}
      />
    )
  }
}
